import { registerArchetype } from './index.js';
import { livingAllies, getRuntimes } from '../combat.js';
registerArchetype({
    id: 'shield',
    apply: ({ state, source, params }) => {
        const amount = params.amount ?? 50;
        const duration = params.duration ?? 5;
        const target = params.target ?? 'self';
        const targets = target === 'all_allies'
            ? livingAllies(state, source.side).map(a => a.slot)
            : [source.slot];
        for (const slot of targets) {
            getRuntimes(state, source.side)[slot].statuses.push({
                id: `shield_${state.tick}_${slot}`,
                kind: 'shield', remainingTicks: duration, params: { amount }
            });
            state.events.push({ t: state.tick, kind: 'status_apply', side: source.side, slot, status: 'shield', duration });
        }
    }
});
